import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

// Sticky mobile CTA bar — shown on landing only, hidden ≥ md.
const StickyMobileCta = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  return (
    <div className="md:hidden fixed bottom-0 inset-x-0 z-30 px-4 pb-3 pt-3 bg-white/85 backdrop-blur-md border-t border-black/5">
      <div className="flex gap-2">
        <button
          data-testid="sticky-cta-reserve"
          onClick={() => navigate('/search')}
          className="flex-1 h-12 rounded-full btn-lime font-comfortaa font-bold text-sm"
        >
          {t('heroCtaPrimary')}
        </button>
        <button
          data-testid="sticky-cta-publish"
          onClick={() => navigate('/become-mobilitier')}
          className="flex-1 h-12 rounded-full btn-ink font-comfortaa font-bold text-sm"
        >
          {t('heroCtaSecondary')}
        </button>
      </div>
    </div>
  );
};

export default StickyMobileCta;
